import { generateAsyncSagaWatcher } from '../../../utils';
import { EHomeActions } from './enums';
import { IHomeResponse } from './models';

export const homeSaga = generateAsyncSagaWatcher<IHomeResponse>(EHomeActions.GET_HOME);
